import { render, staticRenderFns } from "./ServidorDadosFuncionais.vue?vue&type=template&id=248866c6"
import script from "./ServidorDadosFuncionais.vue?vue&type=script&lang=js"
export * from "./ServidorDadosFuncionais.vue?vue&type=script&lang=js"
import style0 from "./ServidorDadosFuncionais.vue?vue&type=style&index=0&id=248866c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports